import { TRequestDto } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Платный контент
 * {@link https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Vas/b5916d3e49d1fa14d5518291ab8bc224 Documentation}
 */
export const vas = (queryParams: TRequestDto): IRequest => ({
    uri: 'v1/vas',
    method: 'GET',
    withProvider: true,
    queryParams,
    withAuth: true,
});
